module.exports = __webpack_public_path__ + "img/notification-gray.eba9c105.svg";